import moment from 'moment';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Column, Row} from '../../../components/layout';
import colors from '../../../util/colors';
import {strings} from '../../../util/strings';
import {UtilizationItem} from '../UtilizationHistory';
import * as fonts from '../../../util/fonts';
import './styles.scss';
import 'moment/locale/sr';
import {Store} from '../../../store';

export interface UtilizationListItemProps {
  utilizationItem: UtilizationItem;
  labels: typeof strings.pt.refund;
  buStyles: any;
  language: any;
  userLanguage: any;
  userSub: any;
}
function UtilizationListItem({
  labels,
  utilizationItem,
  buStyles,
  language,
  userLanguage,
  userSub,
}: UtilizationListItemProps) {
  const defineLang = () => {
    const dateLanguage =
      (language || userLanguage)?.split('-')[0] === 'rs'
        ? 'sr'
        : (language || userLanguage)?.split('-')[0];
    return dateLanguage;
  };

  // Current way of checking if the item was sent by the user is by checking if the submittedGroup contains "MEMB" or "ČLAN"
  // because the submittedGroup is the only field that contains the constistent information about who sent it (Stupidly enough).
  // This is not ideal, but it's a workaround until we have a better way of checking this.
  // "MEMB" - for Portuguese and English language
  // "ČLAN" - for Serbian language
  const isSentByMe =
    utilizationItem.submittedGroup?.toUpperCase().includes('MEMB') ||
    utilizationItem.submittedGroup?.toUpperCase().includes('ČLAN');

  return (
    <>
      <Row>
        <Column
          className="reimbursement-history-declarationlist-column1"
          style={{...fonts.MM}}>
          <strong>
            {moment(utilizationItem.dosFrom)
              .locale(defineLang())
              .format('DD MMM')
              .toUpperCase()}
          </strong>
          {new Date(utilizationItem.dosFrom).getFullYear()}
        </Column>
        <Column className="reimbursement-history-declarationlist-column2">
          <strong
            style={{
              ...fonts.MM,
              ...fonts.Bold,
              color: buStyles?.primaryColor || colors.blue,
            }}>
            {utilizationItem.catName}
          </strong>
          {utilizationItem.clinicName}
        </Column>
        <Column className="reimbursement-history-declarationlist-column3">
          {isSentByMe ? (
            <strong className="utilization-list-item-submittedgroup">
              {labels?.refundDetail_sendByMe}
            </strong>
          ) : (
            ''
          )}
        </Column>
      </Row>
      <div className="reimbursement-history-declarationlist-line"></div>
    </>
  );
}

const mapStateToProps = ({strings, globalStyles, language, user}: any) => ({
  labels: strings.value.pt.refund,
  buStyles: globalStyles.value,
  language: language.value,
  userLanguage: user.value.language,
  userSub: user.value.sub,
});

export default compose(connect(mapStateToProps)(UtilizationListItem));
